<template>
  <b-container>
    <Breadcrumbs crumbString="Products,Graphic Panels,Novalloy+PLUS Commemorative Plaques"></Breadcrumbs>
    <b-row class="image-slider-container">
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>Chemically etched anodized aluminum</div><br>
        <div>Novalloy+PLUS is etched, anodized aluminum, developed specifically for use as commemorative and
          recognition plaques. These plaques carry the same warranty and specifications options as Novalloy
          Metal Micro-imaged signs. See also www.novalloyplus.com</div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <ImageSlider :images="images" class="image-slider"></ImageSlider>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'
  import ImageSlider from '@/components/ImageSlider.vue'

  export default {
    components: {
      Breadcrumbs,
      ImageSlider
    },
    props: {
      images: {
        default: () => [
          require('@/assets/images/pages/novalloy-plus/novalloy-plus-dedication-plaque01.jpg'),
          require('@/assets/images/pages/novalloy-plus/novalloy-plus-dedication-plaque02.jpg'),
          require('@/assets/images/pages/novalloy-plus/novalloy-plus-dedication-plaque03.jpg'),
          require('@/assets/images/pages/novalloy-plus/novalloy-plus-dedication-plaque04.jpg'),
          require('@/assets/images/pages/novalloy-plus/novalloy-plus-dedication-plaque05.jpg'),
          require('@/assets/images/pages/novalloy-plus/novalloy-plus-dedication-plaque06.jpg'),
          require('@/assets/images/pages/novalloy-plus/novalloy-plus-dedication-plaque07.jpg'),
          require('@/assets/images/pages/novalloy-plus/novalloy-plus-dedication-plaque08.jpg'),
          require('@/assets/images/pages/novalloy-plus/novalloy-plus-dedication-plaque09.jpg')
        ],
        type: Array
      }
    },

    data () {
      return {
        title: 'Novalloy+PLUS Commemorative Plaques'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/products/NovalloyPlus.vue